export const getBrowserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

const TIME_LOG_ERROR_KEYS = {
  "A user cannot work more than 12 hours in a single day.": "daily_limit",
  "A user cannot log more than 12 hours in a single day.": "daily_limit",
  "A shift cannot last longer than 24 hours.": "shift_too_long",
  "Clock out must be after clock in.": "check_out_before_check_in",
  "Clock out is required.": "clock_out_required",
  "Clock in must be on the selected day.": "clock_in_other_day",
  "Pause end must be after pause start.": "pause_end_before_start",
  "Pauses must be within the shift.": "pause_outside_shift",
  "Pauses cannot overlap.": "pauses_overlap",
  "Allocated time cannot exceed the worked time of the day.": "allocation_exceeds_worked",
  "Logged time cannot exceed the worked time of the day.": "allocation_exceeds_worked",
  "There is already an active presence for this user.": "active_presence_exists",
};

export const getTimeLogErrorMessage = (error, t, fallback) => {
  const key = TIME_LOG_ERROR_KEYS[error?.detail];
  return key ? t(`common.time_log_errors.${key}`) : fallback;
};
